import type { ProductLogoMediumProps } from "../types";

/**
 * 中サイズのIDAndAccessロゴアイコン
 */
export function ProductLogoMediumIDAndAccess({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <rect width="40" height="40" rx="5.88235" fill="#1A2142" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.6102 18.5946C7.92905 15.8389 9.15552 13.2675 11.0965 11.2855C13.0374 9.30352 15.5825 8.02347 18.3309 7.64698C21.0793 7.27049 23.8749 7.81896 26.2774 9.20601C26.619 9.40325 26.736 9.8401 26.5388 10.1817C26.3416 10.5234 25.9047 10.6404 25.5631 10.4432C23.4352 9.21466 20.9591 8.72887 18.5248 9.06233C16.0905 9.39579 13.8362 10.5296 12.1171 12.2851C10.398 14.0406 9.31171 16.318 9.02931 18.7588C8.7469 21.1996 9.28444 23.6649 10.5573 25.7666C10.7616 26.1041 10.6537 26.5433 10.3163 26.7476C9.97887 26.952 9.53966 26.8441 9.33531 26.5067C7.89825 24.1338 7.29136 21.3503 7.6102 18.5946Z"
        fill="#FCFCFD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.4477 21.4648C32.1289 24.2205 30.9024 26.7919 28.9615 28.7739C27.0206 30.7559 24.4755 32.036 21.727 32.4125C18.9786 32.7889 16.183 32.2405 13.7806 30.8534C13.4389 30.6562 13.3219 30.2193 13.5191 29.8777C13.7164 29.5361 14.1532 29.419 14.4949 29.6163C16.6227 30.8448 19.0988 31.3306 21.5331 30.9971C23.9675 30.6636 26.2217 29.5299 27.9408 27.7744C29.6599 26.0189 30.7462 23.7414 31.0286 21.3006C31.311 18.8599 30.7735 16.3945 29.5007 14.2928C29.2963 13.9554 29.4042 13.5162 29.7416 13.3118C30.0791 13.1075 30.5183 13.2153 30.7226 13.5528C32.1597 15.9256 32.7666 18.7091 32.4477 21.4648Z"
        fill="#FCFCFD"
      />
      <path
        d="M15.147 27.6189L11.8877 28.4922C11.6337 28.5603 11.483 28.8214 11.551 29.0754L12.4243 32.3346C12.5341 32.7444 13.0846 32.8169 13.2967 32.4495L15.6826 28.317C15.8947 27.9496 15.5567 27.5091 15.147 27.6189Z"
        fill="#FCFCFD"
      />
      <path
        d="M24.7252 12.3737L27.9844 11.5004C28.2384 11.4324 28.3892 11.1713 28.3211 10.9172L27.4478 7.65801C27.338 7.24823 26.7876 7.17576 26.5755 7.54316L24.1896 11.6757C23.9774 12.0431 24.3154 12.4835 24.7252 12.3737Z"
        fill="#FCFCFD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7849 23.9285C18.9546 23.9285 20.7135 22.1696 20.7135 19.9999C20.7135 17.8302 18.9546 16.0714 16.7849 16.0714C14.6152 16.0714 12.8563 17.8302 12.8563 19.9999C12.8563 22.1696 14.6152 23.9285 16.7849 23.9285ZM16.7849 21.7856C17.7711 21.7856 18.5706 20.9862 18.5706 19.9999C18.5706 19.0137 17.7711 18.2142 16.7849 18.2142C15.7987 18.2142 14.9992 19.0137 14.9992 19.9999C14.9992 20.9862 15.7987 21.7856 16.7849 21.7856Z"
        fill="#57D7D9"
      />
      <path
        d="M27.1517 18.9381L19.7708 18.9381C19.5078 18.9381 19.2946 19.1513 19.2946 19.4143V20.6048C19.2946 20.8678 19.5078 21.081 19.7708 21.081H21.1836C21.3081 21.081 21.4278 21.1298 21.5168 21.217L22.503 22.1831C22.6881 22.3644 22.9843 22.3644 23.1695 22.1831L23.9316 21.4365C24.1167 21.2552 24.4129 21.2552 24.598 21.4365L25.3601 22.1831C25.5453 22.3644 25.8415 22.3644 26.0266 22.1831L27.1517 21.081C27.1517 21.0809 27.1517 21.0809 27.1517 21.0809L27.9093 20.3233C28.0826 20.15 28.0826 19.869 27.9093 19.6957L27.1517 18.9381Z"
        fill="#57D7D9"
      />
    </svg>
  );
}
